<template>
  <CRow>
    <CCol lg="12">
      <CCard class="mb-1">
        <CCardHeader class="p-1 m-1">
          <strong>Thông tin dự án:</strong>
          <div class="card-header-actions d-flex align-items-center">

            <span>BOM: </span>
            <CSelect class="ml-1 mr-2 pt-3"
                     :value.sync="selectedBom"
                     :options="bomOptions"
                     placeholder="Chọn BOM"
                     @update:value="handleSelectBomChanged">

            </CSelect>

            <CButton type="button" shape="pill" color="info"
                     class="mr-1"
                     @click="editBom"><CIcon name="cil-pencil" class="mr-1"/>
              {{buttonText}}
              </CButton>

            <CButton type="button" shape="pill" color="info"
                     class="mr-1" style=" width: 100px;"
                     @click="save">
              <CIcon name="cil-save"/>
              Lưu lại</CButton>

            <CButton type="button" shape="pill" color="secondary"
                     class="mr-1" style=" width: 100px;"
                     @click="refresh">
              <CIcon name="cil-sync"/>
              Tải lại</CButton>
            <CButton v-if="getAllowDeleteButton" type="button" shape="pill" color="danger"
                     class="mr-1" style=" width: 100px;"
                     @click="deleteProject">
              <CIcon name="cil-trash"/>
              Xóa</CButton>
            <CButton type="button" shape="pill" color="secondary"
                     class="mr-1" style=" width: 100px;"
                     @click="goBack">
              <CIcon name="cil-chevron-left"/>
              Quay lại</CButton>

          </div>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol sm="6">
              <CInput
                label="Tên dự án*:"
                placeholder="Tên dự án"
                v-model="project.project"
              />
            </CCol>
            <CCol sm="6">
              <CRow class="align-items-center">
                <CCol sm="3" class="text-right">Khách hàng*:</CCol>
                <CCol sm="9">
                  <v-select
                    v-model="project.customer"
                    :options="customer_names"
                    @input="handleCustomerNameUpdate"
                    placeholder="Chọn khách hàng"
                  />
                </CCol>
              </CRow>
            </CCol>
          </CRow>
          <CRow>
            <CCol>
              <CInput
                label="Hợp đồng"
                placeholder="Mã hợp đồng"
                v-model="project.contract"
              />
            </CCol>
            <CCol>
              <CInput
                label="Mã đặt hàng:"
                placeholder="Mã đặt hàng"
                v-model="project.preorder"
              />
            </CCol>
            <CCol>
              <CInput
                label="Hóa đơn"
                placeholder="Mã hóa đơn"
                v-model="project.invoice"
              />
            </CCol>
            <CCol sm="2">
              <CInput
                label="Ngày xuất"
                type="date"
                v-model="project.issued"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="3">
              <CSelect
                label="Quản lý:"
                :options="member_names"
                :value.sync="project.who"
                placeholder="Người quản lý dự án"
                required
                :addLabelClasses="'text-right'"
              />
            </CCol>
            <CCol sm="3">
              <CSelect
                label="Trạng thái"
                :options="['Tạo mới', 'Đã xác nhận', 'Đang thực hiện', 'Quá hạn', 'Hoàn thành', 'Hủy bỏ']"
                :value.sync="project.status"
              />
            </CCol>
            <CCol sm="2">
              <CInput
                label="Bắt đầu"
                type="date"
                v-model="project.start"
              />
            </CCol>
            <CCol sm="2">
              <CInput
                label="Kết thúc"
                type="date"
                v-model="project.stop"
              />
            </CCol>
            <CCol sm="2">
              <CInput
                label="Ưu tiên"
                type="number"
                placeholder="3"
                v-model.number="project.priority"
                min="0"
                max="5"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol lg="8">
              <CRow>
                <CCol lg="3">
                  <CInput
                    label="Thiết kế"
                    type="date"
                    v-model="project.design"
                  />
                </CCol>
                <CCol>
                  <CInput
                  label="Thông tin thiết kế"
                  type="text"
                  v-model="project.design_note"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="3">
                  <CInput
                    label="Chuẩn bị vật tư"
                    type="date"
                    v-model="project.material"
                  />
                </CCol>
                <CCol>
                  <CInput
                    label="Thông tin chuẩn bị vật tư"
                    type="text"
                    v-model="project.material_note"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="3">
                  <CInput
                    label="Sản xuất"
                    type="date"
                    v-model="project.manufacture"
                  />
                </CCol>
                <CCol>
                  <CInput
                    label="Thông tin sản xuất"
                    type="text"
                    v-model="project.manufacture_note"
                  />
                </CCol>
              </CRow>
            </CCol>
            <CCol>
            <CTextarea
              label="Ghi chú:"
              type="text"
              placeholder="Ghi chú dự án"
              rows="9"
              v-model="project.note"
            />
            </CCol>
          </CRow>

          <CRow>
            <CCol md="3" class="text-right mt-1 p-0">
              Đính kèm bản cứng:
            </CCol>
            <CCol>
              <CSpinner
                v-if="isUploading"
                color="info"
                class="mr-5 mt-0"
                style="width:1.2rem;height:1.2rem;"
              />

              <CIcon name="cil-paperclip" size="lg" class="mr-2"/>
              <label
                style="border: 1px solid #ced4da;border-radius: 0.375rem;padding: 0.375rem 0.75rem;"
                class="mr-1"
                for="fileInput"
              >{{ fileName }}
              </label>
              <input type="file"
                     id="fileInput"
                     style="display: none;"
                     @change="onFileChange">

              <CButton v-if="selectedFile" shape="pill" color="info"
                       class="mr-2"
                       @click="handleUpload"
                       :disabled="isUploading"
              >
                <CIcon name="cil-cloud-upload"/>
                {{ isUploading ? "Đang tải..." : "Tải lên" }}
              </CButton>

              <CButton v-if="gotInfo && project.attached" shape="pill" color="info"
                       class="mr-2"
                       @click="downloadFile(project.attached)"
              ><CIcon name="cil-cloud-download" class="mr-1"/>Tải xuống</CButton>

              <CButton v-if="gotInfo && project.attached" shape="pill" color="info"
                       @click="previewFile(project.attached)"
              ><CIcon name="cil-screen-desktop" class="mr-1"/>Xem/Ẩn</CButton>

            </CCol>
          </CRow>

          <div v-if="pdfUrl" class="resizable-container mb-2">
            <iframe :src="pdfUrl" width="100%" height="100%"></iframe>
          </div>


        </CCardBody>
      </CCard>

      <CCard>
        <CCardHeader>
          <strong>Sản phẩm:</strong>
          <div class="card-header-actions">
            <CButton @click="createDeliver" color="info"
            class="mr-1">
              <CIcon name="cil-truck" class="mr-1"/>
              Tạo phiếu giao hàng </CButton>
            <CButton @click="createGuarantee" color="info" class="mr-1">
              <CIcon name="cib-hackaday" class="mr-1"/>
              Tạo phiếu bảo hành</CButton>
            <CButton @click="addProductModal=true" color="info"
                     class="mr-1">
              <CIcon name="cil-plus" class="mr-1"/>
              Thêm sản phẩm</CButton>
          </div>
        </CCardHeader>
        <CCardBody>
          <CDataTable
            :items="products_used"
            table-class="table-sm"
            :fields="productsHeader"
          >
            <template #no-items-view>
              <div style="color: #888; text-align: center; padding: 10px; font-style: italic;">
                Danh sách trống!
              </div>
            </template>

            <template #stt="{item, index}">
              <td class="py-2">
                {{index+1}}
              </td>
            </template>

            <template #quantity="{item, index}">
              <td class="text-right">
                {{formatNumber(item.quantity)}}
              </td>
            </template>
            
            <template #manufactured="{item, index}">
              <td @click.stop="viewManufactured(item)" class="cursor-pointer">
                <CCol>
                  <div class="text-center">{{formatNumber(item.manufactured)}}/{{formatNumber(item.quantity)}}</div>
                  <CProgress :value="item.manufactured" :max="item.quantity"
                           show-percentage color="gradient-info"/>
                </CCol>
              </td>
            </template>

            <template #delivered="{item, index}">
              <td @click.stop="viewDelivered(item)" class="cursor-pointer">
                <CCol>
                  <div class="text-center">{{formatNumber(item.delivered)}}/{{formatNumber(item.quantity)}}</div>
                  <CProgress :value="item.delivered" :max="item.quantity"
                           show-percentage color="gradient-success"/>
                </CCol>
              </td>
            </template>

            <template #remaining="{item, index}">
              <td class="text-right">
                <div class="text-center font-weight-bold text-danger">{{formatNumber(item.quantity - item.delivered)}}</div>
              </td>
            </template>

            <template #guaranteed="{item, index}">
              <td @click.stop="viewGuaranteed(item)" class="cursor-pointer">
                <CCol>
                  <div class="text-center">{{formatNumber(item.guaranteed)}}/{{formatNumber(item.quantity)}}</div>
                  <CProgress :value="item.guaranteed" :max="item.quantity"
                           show-percentage :precision="2" color="gradient-danger"/>
                </CCol>
              </td>
            </template>

            <template #actions="{item, index}">
              <td class="text-right">
                  <CButton variant="ghost" color="primary" size="sm" 
                           @click="editProduct(index)"
                           class="mr-1">
                    <CIcon name="cil-pencil"/>
                  </CButton>
                  <CButton variant="ghost" color="danger" size="sm" 
                           @click="removeProduct(index)">
                    <CIcon name="cil-trash"/>
                  </CButton>
              </td>
            </template>

          </CDataTable>

        </CCardBody>
      </CCard>
    </CCol>

    <CModal
      :show.sync="addBomModal"
      :no-close-on-backdrop="true"
      title="Modal title 2"
      color="info"
      :centered="true"
    >
      <CRow class="m-0 p-0 pb-3">
        <CCol class="d-flex justify-content-center align-items-center">
          <strong>Lưu ý: Trong một dự án, tên các BOM phải khác nhau </strong></CCol>
      </CRow>
      <CInput label="Đặt tên BOM:" type="text"
              placeholder="Nhập tên BOM"
              v-model="bomRequest.bom_name"
              :addLabelClasses="'text-right'"
              :horizontal="{ label: 'col-sm-4', input: 'col-sm-8'}"/>
      <CInput label="Số lượng sản phẩm:" type="number"
              placeholder="Nhập số sản phẩm"
              v-model.number="bomRequest.quantity"
              :addLabelClasses="'text-right'"
              :horizontal="{ label: 'col-sm-4', input: 'col-sm-8'}"/>
      <template #header>
        <strong class="modal-title">
          Tạo mới BOM</strong>
        <CButtonClose @click="addBomModal = false" class="text-white"/>
      </template>
      <template #footer>
        <CButton color="info"
                 @click="createNewBom">
          <CIcon name="cil-plus" class="mr-2"/>Tạo</CButton>
        <CButton @click="addBomModal = false" color="secondary"><CIcon name="cil-x" class="mr-2"/>Đóng</CButton>
      </template>
    </CModal>

    <CModal
      :show.sync="addProductModal"
      :no-close-on-backdrop="true"
      title="Modal title 2"
      color="info"
      :centered="true"
    >
      <CSelect
        label="Sản phẩm*:"
        :options="product_names"
        @update:value="handleProductNameUpdate"
        :value.sync="productNameRequest"
        :addLabelClasses="'text-right'"
        placeholder="Chọn sản phẩm"
        :horizontal="{ label: 'col-sm-4', input: 'col-sm-8'}"
      />

      <CInput label="Số lượng sản phẩm:" type="number"
              placeholder="Nhập số sản phẩm"
              v-model.number="productQuantityRequest"
              :addLabelClasses="'text-right'"
              :horizontal="{ label: 'col-sm-4', input: 'col-sm-8'}"/>
      <template #header>
        <strong class="modal-title">
          Thêm sản phẩm cho dự án</strong>
        <CButtonClose @click="addProductModal = false" class="text-white"/>
      </template>
      <template #footer>
        <CButton color="info"
                 @click="addProduct">
          <CIcon name="cil-plus" class="mr-2"/>Thêm sản phẩm</CButton>
        <CButton @click="addProductModal = false" color="secondary"><CIcon name="cil-x" class="mr-2"/>Đóng</CButton>
      </template>
    </CModal>

    <CModal
      :show.sync="editProductModal"
      :no-close-on-backdrop="true"
      title="Modal title 2"
      color="info"
      :centered="true"
    >
      <template #header>
        <strong class="modal-title">
          Sửa thông tin sản phẩm</strong>
        <CButtonClose @click="editProductModal = false" class="text-white"/>
      </template>

      <CSelect
        label="Sản phẩm*:"
        :options="product_names"
        @update:value="handleProductNameUpdateEdit"
        :value.sync="productEditData.product"
        :addLabelClasses="'text-right'"
        placeholder="Chọn sản phẩm"
        :horizontal="{ label: 'col-sm-4', input: 'col-sm-8'}"
      />

      <CInput label="Số lượng sản phẩm:" type="number"
              placeholder="Nhập số sản phẩm"
              v-model.number="productEditData.quantity"
              :addLabelClasses="'text-right'"
              :horizontal="{ label: 'col-sm-4', input: 'col-sm-8'}"/>

      <template #footer>
        <CButton color="info"
                 @click="updateProduct">
          <CIcon name="cil-save" class="mr-2"/>
          Cập nhật
        </CButton>
        <CButton @click="editProductModal = false" color="secondary"><CIcon name="cil-x" class="mr-2"/>Đóng</CButton>
      </template>
    </CModal>

  </CRow>
</template>

<script>
import 'vue-select/dist/vue-select.css'
import vSelect from 'vue-select'

export default {
  components: { vSelect },

  data() {
    const today = new Date();
    const future = new Date();
    future.setMonth(future.getMonth() + 6);
    const startStr=today.toISOString().split("T")[0]
    const stopStr=future.toISOString().split("T")[0]
    // console.log(startStr, stopStr)
    return {
      productsHeader: [
        { key: 'stt', label: 'Stt', _style:'width:3rem;' },
        { key: 'product', label: 'Tên sản phẩm', _classes: 'font-weight-bold' },
        { key: 'quantity', label: 'Số lượng' },
        { key: 'manufactured', label: 'Sản xuất' , _classes: 'text-center'  },
        { key: 'delivered', label: 'Giao hàng' , _classes: 'text-center'  },
        { key: 'remaining', label: 'Còn lại' , _classes: 'text-center'  },
        { key: 'guaranteed', label: 'Bảo hành' , _classes: 'text-center'  },
        { key: 'actions', label: 'Thao tác' , _classes: 'text-right',  _style:'width:10rem;'  }],
      projectID: '',
      project: { // project basic info
        id: 0,
        project: '',
        preorder: '',
        customer: '',
        contract: '',
        product: '',
        quantity: 0,
        who: '',
        start: startStr,
        stop: stopStr,
        status: 'Tạo mới',
        priority: 3,
        invoice: '',
        issued: '',
        note: '',
        updated: '',
        design: '',
        design_note: '',
        material: '',
        material_note: '',
        manufacture: '',
        manufacture_note: '',
      },
      otp: '',
      isSuper: false,
      selectedFile: null,
      isUploading: false,
      progress: null,
      gotInfo: false,
      preview: true,
      pdfUrl: null,
      fileName: 'Chọn tệp máy tính',
      products_used: [],
      customer_names: [],
      product_names: [],
      member_names: [],
      bomOptions: ['Tạo mới'],
      bomList: [],
      selectedBom: '',
      buttonText: 'Tạo mới',
      addBomModal: false,
      addProductModal: false,
      editProductModal: false,
      productNameRequest: '',
      productQuantityRequest: 0,
      productEditIndex: -1,
      productEditData: {
        product: '',
        quantity: 0,
      },
      bomRequest: {
        bom_name: 'Tạo mới',
        project: '',
        quantity: 0,
      }
    }
  },
  created() {
    this.getSuper()
    this.projectID = this.$route.query.id
    this.getProjectDetail(this.projectID);
  },
  computed:{
    getAllowDeleteButton() {
      return this.isSuper
    }
  },
  methods: {
    getSuper() {
      const role = localStorage.getItem('role')
      this.isSuper = ((role === 'root'))
    },
    getProjectDetail(projectID) {
      //console.log('do get user detail for: ', projectID);
      this.$request.get(`/api/project/${projectID}`).then(res => {
        //console.log(res.data);
        if(res.data.product_names) {
          this.product_names = res.data.product_names;
        }
        this.product_names.push('Tạo mới')

        this.customer_names = (res.data.customer_names || []).filter(name => name !== 'Công ty tôi')
        this.customer_names.push('Tạo mới')

        if(res.data.member_names) {
          this.member_names = res.data.member_names
        }

        if (this.projectID || this.project.project) {
          this.project = res.data.project;
          this.products_used = res.data.products_used;
          this.bomRequest.project = this.project.project;
          if(this.project.attached!=='') {
            this.fileName = this.project.attached;
          }
          this.gotInfo=true

          if(res.data.list_bom) {
            this.bomList = res.data.list_bom;
            this.bomOptions = this.bomList.map(item => item.bom_name)
            this.bomOptions.push('Tạo mới')
          } else {
            this.bomOptions = ['Tạo mới']
          }
        }
        this.selectedBom = this.bomOptions[0]
        this.handleSelectBomChanged(this.selectedBom)
      })
    },
    refresh() {
      if (this.projectID) {
        this.getProjectDetail(this.projectID)
      }
    },
    deleteProject() {
      // console.log("Deleting item with name:", this.project.project);
      this.$swal.fire({
        title: "Xóa dự án?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.delete(`/api/project/delete/${this.project.id}`).
          then(res => {
            if(res.data.status === 'success') {
              this.$swal.fire({
                icon: "success",
                title: "Xóa dự án",
                html: "Xóa dự án: " + this.project.project + " thành công" ,
              });
              this.$router.go(-1);
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Xóa dự án",
                html: "Xóa dự án: " + this.project.project +
                  "<br> lỗi: " + res.data.status,
              });
            }
          })
        }
      });
    },
    save() {
      this.$swal.fire({
        title: "Cập nhật dự án?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.post(`/api/project/basic`,
            {
              otp: this.otp,
              project: this.project,
              products_used: this.products_used,
            } ).then(res => {
            this.project = res.data.project;
            if(res.data.status === 'success') {
              this.$swal.fire({
                icon: "success",
                title: "Cập nhật  dự án",
                text: "Cập nhật dự án: " + this.project.project + " thành công" ,
              });
              // this.$router.go(-1);
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Cập nhật dự án",
                html: "Cập nhật dự án:  " + this.project.project +
                  "<br>lỗi: " + res.data.status,
              });
            }
          })
        }
      });
    },
    goBack() {
      this.$router.go(-1)
    },
    onFileChange(event) {
      this.selectedFile = event.target.files[0];
      if (this.selectedFile) {
        this.fileName = this.selectedFile.name;
        // console.log('selected file name:', this.fileName)
      } else {
        // console.log('no file selected');
        this.fileName = 'Chọn tệp máy tính'
      }
    },
    handleUpload() {
      if (!this.selectedFile) {
        this.$swal.fire({
          icon: "error",
          title: "Tải lên",
          text: "Vui lòng chọn tệp trước"
        });
        return;
      }

      // Create FormData instance to hold the file
      this.isUploading = true;
      const formData = new FormData();
      formData.append("file", this.selectedFile);
      formData.append("id", this.project.id)
      // Send file using Axios
      this.$request.post(`/api/project/docupload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        if (res.data.status === 'success') {
          // console.log(res.data.status)
          this.$swal.fire({
            icon: "success",
            title: "Tải lên tệp",
            text: "Tệp: " + this.fileName + " đã tải lên thành công!",
          });
          this.project.attached=this.fileName;
          if(this.userRole === 'customer') {this.project.customer=this.userName}
          this.$request.post(`/api/project/basic`,
            {otp: this.otp, project: this.project}).
          then(res => {
            if(res.data.status === 'success') {
              this.project = res.data.project;
              this.selectedFile=null
              this.gotInfo = true
            }
          })
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Tải lên tệp",
            html: "Tệp: " + this.fileName + " lưu lỗi: "+ res.data.status,
          });
        }
        this.isUploading = false;
      })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Lưu tệp đính kèm",
            html: "Tệp: " + this.fileName + " lưu lỗi: " + error,
          });
          this.isUploading = false;
        });
    },
    downloadFile(fileName) {
      // console.log('downloadFile', fileName)
      this.$request.get(`/api/project/docdownload/${fileName}?id=${this.project.id}`,
        { responseType: 'blob' })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = fileURL;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(fileURL);
          // document.body.removeChild(link); // Clean up
        })
        .catch(error => {
          console.error('Error downloading the file:', error);
        });
    },
    previewFile(fileName) {
      // console.log('previewFile', fileName, 'id:', this.project.id);
      if (this.pdfUrl) {
        this.pdfUrl = null
        return
      }
      this.$request.get(`/api/project/docdownload/${fileName}?id=${this.project.id}&&preview=yes`, {
        responseType: 'blob'
      }).then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        this.pdfUrl = URL.createObjectURL(blob);
      }).catch((error) => {
        console.error("Error converting DOCX to PDF:", error);
      });
    },
    newCustomer() {
      this.$router.push({
        path: '/device/cusedit',
      })
    },
    newProduct() {
      this.$router.push({
        path: '/device/prodedit',
      })
    },
    handleCustomerNameUpdate(newValue) {
      if (newValue === 'Tạo mới') {
        this.newCustomer()
      }
    },
    handleProductNameUpdate(newValue) {
      if (newValue === 'Tạo mới') {
        this.newProduct()
      }
    },
    viewManufactured(item) {
      if(this.project.project) {
        // console.log('viewManufactured', this.project.project);
        this.$router.push({
          path: `/device/products`,
          query: {
            project: this.project.project,
          },
        })
      }
    },
    viewDelivered(item) {
      if(this.project.project) {
        // console.log('viewDelivered', this.project.project);
        this.$router.push({
          path: `/device/deliver`,
          query: {
            project: this.project.project,
          },
        })
      }
    },
    viewGuaranteed(item){
      if(this.project.project) {
        // console.log('viewGuaranteed', this.project.project);
        this.$router.push({
          path: `/device/guarantee`,
          query: {
            project: this.project.project,
          },
        })
      }
    },
    createDeliver() {
      if(this.project.project) {
        // console.log('createDeliver', this.project.project);
        if(this.products_used.length > 0) {
          this.project.product = this.products_used[0].product;
        }
        this.$router.push({
          path: `/device/deledit`,
          query: {
            project: this.project.project,
            customer: this.project.customer,
            products: this.products_used,
          },
        })
      }
    },
    createGuarantee() {
      if(this.project.project) {
        // console.log('createGuarantee', this.project.project);
        if(this.products_used.length > 0) {
          this.project.product = this.products_used[0].product;
        }
        this.$router.push({
          path: `/device/guaedit`,
          query: {
            project: this.project.project,
            customer: this.project.customer,
            product: this.project.product,
          },
        })
      }
    },
    handleSelectBomChanged(newValue) {
      if (newValue === 'Tạo mới') {
        this.buttonText = 'Tạo mới'
      } else {
        this.buttonText = 'Biên tập'
        let index = this.bomList.findIndex(item => item.bom_name === newValue);
        if(index >= 0) {
          this.bomRequest = this.bomList[index];
        }
        // console.log(this.bomRequest);
      }
    },
    editBom(){
      if(this.selectedBom === 'Tạo mới') {
        this.bomRequest.bom_name = ''
        this.bomRequest.quantity = 0
        this.bomRequest.id = 0
        this.addBomModal=true
      } else {
        this.$router.push({
          path: '/project/bom',
          query: this.bomRequest
        })
      }
    },
    createNewBom(){
      if(this.bomRequest.quantity === 0 || this.bomRequest.bom_name === '') {
        // console.log('createNewBom invalid params');
        return
      }
      this.bomRequest.bom_name = this.bomRequest.project + '_' +this.bomRequest.bom_name
      this.$request.post(`/api/project/bom/create`,
        this.bomRequest ).then(res => {
        // console.log(res.data);
        if(res.data.status === 'success') {
          this.$router.push({
            path: '/project/bom',
            query: this.bomRequest,
          })
        } else {
          this.bomRequest.bom_name = ''
          this.$swal.fire({
            icon: "error",
            title: "Cập nhật dự án",
            html: "Cập nhật dự án:  " + this.project.project +
              "<br>lỗi: " + res.data.status,
          });
        }
      })
    },
    addProduct() {
      if (!this.productNameRequest || this.productQuantityRequest <= 0) return

      if (!Array.isArray(this.products_used)) {
        this.products_used = []
      }

      const exists = this.products_used.some(
        (item) => item.product === this.productNameRequest
      )

      if (exists) {
        return
      }

      this.products_used.push({
        project: this.project.project,
        product: this.productNameRequest,
        quantity: this.productQuantityRequest,
      })

      this.productNameRequest = ''
      this.productQuantityRequest=0
      this.addProductModal=false
    },
    editProduct(index) {
      this.productEditIndex = index
      const product = this.products_used[index]
      this.productEditData = {
        product: product.product,
        quantity: product.quantity,
      }
      this.editProductModal = true
    },
    updateProduct() {
      // console.log('updateProduct', this.productEditData)
      if (!this.productEditData.product || this.productEditData.quantity <= 0) return

      // console.log('updateProduct index', this.productEditIndex)
      if (this.productEditIndex >= 0 && this.productEditIndex < this.products_used.length) {
        this.products_used[this.productEditIndex].product = this.productEditData.product
        this.products_used[this.productEditIndex].quantity = this.productEditData.quantity
      }

      this.productEditIndex = -1
      this.productEditData = {
        product: '',
        quantity: 0,
      }
      this.editProductModal = false
    },
    handleProductNameUpdateEdit(newValue) {
      if (newValue === 'Tạo mới') {
        this.newProduct()
      }
    },
    removeProduct(index) {
      this.products_used.splice(index, 1)
    },
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.resizable-container {
  width: 100%;
  height: 700px;
  resize: vertical; /* Allows vertical resizing */
  overflow: auto; /* Ensures scrollbars appear when needed */
  border: 1px solid #ccc; /* Optional: for better visibility */
  padding: 5px;
}
</style>
